import React from "react";
import { Slang } from "../../helpers";
import { Link } from "react-router-dom";

const Hero = () => {
  const lang = Slang("home.hero");

  return (
    <>
      <div
        className="position-relative bg-img-start"
        style={{
          backgroundImage: "url(./assets/img/1920x1080/img6.jpg)",
        }}
      >
        <div className="container content-space-t-2 content-space-t-md-3 content-space-3 content-space-b-lg-5">
          <div className="w-lg-50 mt-6">
            {/* <h1 className='text-secondary'>You're in good company.</h1> */}
            <h1 className="h1 text-secondary">
              {lang("t1")}{" "}
              <span className="text-dark text-uppercase">{lang("t2")}.</span>
            </h1>
          </div>
        </div>

        <div
          className="shape shape-bottom zi-1"
          style={{ marginBottom: "-.125rem" }}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            x="0px"
            y="0px"
            viewBox="0 0 1920 100.1"
          >
            <path
              fill="#fff"
              d="M0,0c0,0,934.4,93.4,1920,0v100.1H0L0,0z"
            ></path>
          </svg>
        </div>
      </div>

      <div className="container position-relative zi-2">
        <div className="row justify-content-center mt-n5">
          <div className="col-3 col-lg-2 d-none d-sm-inline-block mt-n10">
            <div className="avatar avatar-xl avatar-circle shadow-sm p-4 mx-auto">
              <img
                className="avatar-img"
                src="./assets/img/svg/brands/behance-icon.svg"
                alt="Description_Image"
              />
            </div>
          </div>

          <div className="col-lg-2 d-none d-lg-inline-block mt-lg-n8">
            <div className="avatar avatar-xxl avatar-circle shadow-sm p-4 mx-auto">
              <img
                className="avatar-img"
                src="./assets/img/svg/brands/google-icon.svg"
                alt="Description_Image"
              />
            </div>
          </div>

          <div className="col-3 col-lg-2 d-none d-sm-inline-block mt-n4">
            <div className="avatar avatar-xl avatar-circle shadow-sm p-4 mx-auto">
              <img
                className="avatar-img"
                src="./assets/img/svg/brands/asana-icon.svg"
                alt="Description_Image"
              />
            </div>
          </div>

          <div className="col-3 col-lg-2 d-none d-sm-inline-block mt-n7">
            <div className="avatar avatar-xl avatar-circle shadow-sm p-4 mx-auto">
              <img
                className="avatar-img"
                src="./assets/img/svg/brands/slack-icon.svg"
                alt="Description_Image"
              />
            </div>
          </div>

          <div className="col-lg-2 d-none d-lg-inline-block mt-lg-n10">
            <div className="avatar avatar-xxl avatar-circle shadow-sm p-4 mx-auto">
              <img
                className="avatar-img"
                src="./assets/img/svg/brands/dropbox-icon.svg"
                alt="Description_Image"
              />
            </div>
          </div>

          <div className="col-3 col-lg-2 d-none d-sm-inline-block">
            <Link to={"/market-place"}>
              <div className="avatar avatar-xl avatar-circle shadow-sm p-4 mx-auto">
                <img
                  className="avatar-img"
                  src="./assets/img/svg/brands/spotify-icon.svg"
                  alt="Description_Image"
                />
              </div>
            </Link>
          </div>
        </div>
      </div>
    </>
  );
};

export default Hero;
